// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_tooltip__x3hRE","title":"tooltip_title__rOPFY","absoluteTooltip":"tooltip_absoluteTooltip__tntI-","subtext":"tooltip_subtext__Gy4r9"};